import React from 'react'
import './App.css'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Contact from './pages/Contact'
import Footer from './pages/Footer'
import Quote from './pages/Quote'
import Reviews from './pages/Reviews'

function App() {

  return (
    <div className="bg-[#f9f9f9]">
      <Home/>
      <About/>
      <Reviews/>
      <Quote/>
      <Services/>
      <Contact/>
      <Footer/>
    </div>
  )
}
export default App;
